import React from "react";
import { useDispatch, useSelector } from 'react-redux';

import { Breadcrumbs, Button } from "@material-ui/core";
import { PersonAdd, Search } from "@material-ui/icons";

import { clearAdicciones, setActiveStepAdicciones, setBreadcrumbCud } from "../../../actions/adicciones/adiccionesActions";
import { MENU_ADICCIONES, STEPPER_ADICCIONES } from "../data/constants";
import { desSeleccionarAfiliado } from "../../../actions/afiliado";
import { limpiarListaDocumentacionAfiliado } from "../../../actions/documentaciones/documentacion";
import { grupoFamiliarLimpiar } from "../../../actions/grupoFamiliar";
import { observacionesLimpiar } from "../../../actions/observaciones";
import { certificadosLimpiar } from "../../../actions/certificados";
import { empresasAfiliadoLimpiar } from "../../../actions/empresasAfiliado";
import { aportesLimpiar } from "../../../actions/aportes";
import { movimientosLimpiar } from "../../../actions/movimientos/movimientos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { ADICCIONES_PERMISOS } from "../../../utils/permisos";

export const AdiccionesBreadcrumb = ({ permisosUser }) => {
  const dispatch = useDispatch();

  const { activeBreadcrumb } = useSelector((state) => state.adicciones);

  const resetMenu = () => {
    dispatch(setBreadcrumbCud(MENU_ADICCIONES.DESELECCIONAR));
    dispatch(desSeleccionarAfiliado());
    dispatch(limpiarListaDocumentacionAfiliado());
    dispatch(grupoFamiliarLimpiar());
    dispatch(observacionesLimpiar());
    dispatch(certificadosLimpiar());
    dispatch(empresasAfiliadoLimpiar());
    dispatch(aportesLimpiar());
    dispatch(movimientosLimpiar());
  }

  return (
    <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
      {validarSoloUnPermiso(
        permisosUser,
        ADICCIONES_PERMISOS.MENU.ALTA
      ) && (
          <Button
            color={
              activeBreadcrumb === MENU_ADICCIONES.INGRESO_SOLICITUD
                ? "default"
                : "inherit"
            }
            onClick={(e) => {
              resetMenu();
              dispatch(clearAdicciones());
              dispatch(setBreadcrumbCud(MENU_ADICCIONES.INGRESO_SOLICITUD));
              dispatch(setActiveStepAdicciones(STEPPER_ADICCIONES.BUSCAR_AFILIADO));
            }}
          >
            <PersonAdd />
            Ingreso de Solicitudes
          </Button>
        )}
      {validarSoloUnPermiso(
        permisosUser,
        ADICCIONES_PERMISOS.MENU.CONSULTA
      ) && (
          <Button
            color={
              activeBreadcrumb === MENU_ADICCIONES.GESTION_SOLICITUD
                ? "default"
                : "inherit"
            }
            onClick={(e) => {
              resetMenu();
              dispatch(clearAdicciones());
              dispatch(setBreadcrumbCud(MENU_ADICCIONES.GESTION_SOLICITUD));
            }}
          >
            <Search />
            Gestión de Solicitudes
          </Button>
        )}
    </Breadcrumbs>
  );
};
